import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { reverse } from "named-urls";
import { PageHeader, Button, notification } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { serviceRequestSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";
import schema from "../../../../schemas/serviceRequestSchema";
import ServiceRequestForm from "../../../../forms/ServiceRequestForm";

const ServiceRequest = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: serviceRequestSaga });
  const dispatch = useDispatch();
  const history = useHistory();

  const { orderId } = useParams();
  const id = orderId;

  useEffect(() => {
    dispatch(actions.fetchOrderDetails(id));
  }, [dispatch, id]);

  const orderDetails = useSelector(selectors.selectOrderDetails) || {};
  const { user } = orderDetails;
  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);

  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Raising Service Request",
        description: error,
      });
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1500);
    }
  }, [error, dispatch]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: "",
      subject: "",
      message: "",
    },
  });

  const handleSuccess = () => {
    notification.success({
      message: "Service Request raised successfully",
    });
    history.push(reverse(`${routes.backOffice.orders}`));
  };

  const handleFailure = () => {
    console.log("An error occured");
  };

  useEffect(() => {
    reset(user);
  }, [reset, user]);

  const onSubmit = (data) => {
    const payloadData = {
      email: data.email,
      subject: data.subject,
      message: data.message,
      orderId: orderDetails._id,
    };
    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };

    dispatch(actions.createServiceRequest(payload));
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="Raise Request For Service"
        subTitle={orderDetails.orderId}
        extra={[
          <Button
            key="1"
            onClick={() => {
              history.goBack();
            }}
          >
            Cancel
          </Button>,
          <Button
            disabled={loading}
            loading={loading}
            key="2"
            type="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <ServiceRequestForm control={control} errors={errors} />
      </div>
    </div>
  );
};

export default ServiceRequest;
